// extracted by mini-css-extract-plugin
export var postFooter = "style-module--post-footer--6099d";
export var postFooterSmall = "style-module--post-footer-small--b85b5";
export var postFooter__socials = "style-module--post-footer__socials--57ce2";
export var postFooter__socialsSmall = "style-module--post-footer__socials-small--b9e62";